import { Navigate, useParams } from "react-router";
import { hermesTemplateMessageQueueDetailPath } from "../../constants/routes";

/**
 * O detalhe de uma intenção da Fila de Disparo morava em
 * `/backoffice/hermes/whatsapp-messages/:id`; hoje esse prefixo é a lista de
 * Mensagens. Links antigos (o `id` é o mesmo) seguem para o endereço novo.
 */
export const LegacyQueueDetailRedirect = () => {
  const { id = "" } = useParams();
  return <Navigate to={hermesTemplateMessageQueueDetailPath(id)} replace />;
};
